/* ==========================================================================
   Puure Filter Questionnaire — JS Logic Engine
   Vanilla JS | No dependencies | Shopify 2.0
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- Config ---------- */
  var WEBHOOK_URL = 'https://n8n.srv1334841.hstgr.cloud/webhook/filter-selection';

  var configEl = document.getElementById('pqFlowConfig');
  if (!configEl) return;

  var CONFIG = JSON.parse(configEl.textContent);
  var QUESTIONS = CONFIG.questions;
  var START = CONFIG.startQuestion;
  var END_SCREEN = CONFIG.endScreen;
  var UI = CONFIG.ui || {};

  /* ---------- State ---------- */
  var state = {
    current: START,
    history: [],
    answers: {},
    photos: {},
    finished: false
  };

  /* ---------- DOM ---------- */
  var root = document.getElementById('puure-questionnaire');
  var cardsContainer = document.getElementById('pqCards');
  var progressBar = document.getElementById('pqProgressBar');
  var btnBack = document.getElementById('pqBack');
  var btnNext = document.getElementById('pqNext');
  var nav = document.getElementById('pqNav');

  /* ---------- Helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function getKeys() { return Object.keys(QUESTIONS); }

  function getTotalSteps() {
    return state.history.length + estimateRemaining(state.current, 0);
  }

  function estimateRemaining(qId, depth) {
    if (!qId || qId === 'END' || depth > 20) return 0;
    var q = QUESTIONS[qId];
    if (!q) return 0;
    var next = typeof q.next === 'string' ? q.next : (q.next._default || q.next[Object.keys(q.next)[0]]);
    return 1 + estimateRemaining(next, depth + 1);
  }

  function updateProgress() {
    var total = getTotalSteps();
    var current = state.history.length;
    var pct = total > 0 ? Math.min((current / total) * 100, 100) : 0;
    if (state.finished) pct = 100;
    progressBar.style.width = pct + '%';
  }

  function getNextQuestion(q, answer) {
    if (!q.next) return 'END';
    if (typeof q.next === 'string') return q.next;
    if (q.next[answer]) return q.next[answer];
    if (q.next._default) return q.next._default;
    return 'END';
  }

  /* ---------- SVG Icons ---------- */
  var ICONS = {
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    upload: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>',
    alert: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>',
    none: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>',
    checkCircle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>'
  };

  /* ---------- Renderers ---------- */

  function renderYesNo(q) {
    var sel = state.answers[q.id] || '';
    return '<div class="pq__yesno">' +
      '<button type="button" class="pq__yesno-btn' + (sel === 'yes' ? ' pq__yesno-btn--selected' : '') + '" data-value="yes">' +
        ICONS.check + '<span>' + (UI.yes || 'Yes') + '</span>' +
      '</button>' +
      '<button type="button" class="pq__yesno-btn' + (sel === 'no' ? ' pq__yesno-btn--selected' : '') + '" data-value="no">' +
        ICONS.x + '<span>' + (UI.no || 'No') + '</span>' +
      '</button>' +
    '</div>';
  }

  function renderSingleChoice(q) {
    var sel = state.answers[q.id] || '';
    var keys = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var html = '<div class="pq__choices">';
    q.choices.forEach(function (c, i) {
      html += '<button type="button" class="pq__choice-btn' + (sel === c.value ? ' pq__choice-btn--selected' : '') + '" data-value="' + c.value + '">' +
        '<span class="pq__choice-key">' + keys[i] + '</span>' +
        '<span class="pq__choice-content">' +
          '<span class="pq__choice-label">' + c.label + '</span>' +
          (c.description ? '<span class="pq__choice-desc">' + c.description + '</span>' : '') +
        '</span>' +
      '</button>';
    });
    html += '</div>';
    return html;
  }

  function renderPictureChoice(q) {
    var sel = state.answers[q.id] || '';
    var count = q.choices.length;
    var html = '<div class="pq__pictures' + (count === 4 ? ' pq__pictures--four' : '') + '">';
    q.choices.forEach(function (c) {
      var isNone = !c.image;
      html += '<button type="button" class="pq__picture-btn' + (sel === c.value ? ' pq__picture-btn--selected' : '') + '" data-value="' + c.value + '">';
      if (isNone) {
        html += '<div class="pq__picture-img--none">' + ICONS.none + '</div>';
      } else {
        html += '<img class="pq__picture-img" src="' + c.image + '" alt="' + c.label + '" loading="lazy">';
      }
      html += '<span class="pq__picture-label">' + c.label + '</span>';
      html += '</button>';
    });
    html += '</div>';
    return html;
  }

  function renderTextInput(q) {
    var val = state.answers[q.id] || '';
    var type = q.type === 'email' ? 'email' : (q.type === 'number' ? 'number' : 'text');
    var html = '<div class="pq__input-wrap">' +
      '<input class="pq__input" type="' + type + '" ' +
        'placeholder="' + (q.placeholder || '') + '" ' +
        'value="' + val.replace(/"/g, '&quot;') + '" ' +
        (type === 'number' ? 'step="0.1" min="0" ' : '') +
        'autocomplete="off" data-qid="' + q.id + '">';
    if (q.unit) {
      html += '<span class="pq__input-unit">' + q.unit + '</span>';
    }
    html += '</div>';
    if (q.validation === 'order_number') {
      html += '<div class="pq__order-badge" data-qid="' + q.id + '"></div>';
    }
    return html;
  }

  function renderNameEmail(q) {
    var nameVal = state.answers[q.id + '_name'] || '';
    var emailVal = state.answers[q.id + '_email'] || '';
    return '<div class="pq__name-email">' +
      '<div class="pq__input-wrap">' +
        '<label class="pq__input-label" for="pqName_' + q.id + '">' + (UI.full_name || 'Full name') + '</label>' +
        '<input class="pq__input" type="text" id="pqName_' + q.id + '" ' +
          'placeholder="John Doe" ' +
          'value="' + nameVal.replace(/"/g, '&quot;') + '" ' +
          'autocomplete="name" data-qid="' + q.id + '" data-field="name">' +
      '</div>' +
      '<div class="pq__input-wrap">' +
        '<label class="pq__input-label" for="pqEmail_' + q.id + '">' + (UI.email_address || 'Email address') + '</label>' +
        '<input class="pq__input" type="email" id="pqEmail_' + q.id + '" ' +
          'placeholder="your@email.com" ' +
          'value="' + emailVal.replace(/"/g, '&quot;') + '" ' +
          'autocomplete="email" data-qid="' + q.id + '" data-field="email">' +
      '</div>' +
    '</div>';
  }

  function renderTextarea(q) {
    var val = state.answers[q.id] || '';
    return '<textarea class="pq__textarea" placeholder="' + (q.placeholder || '') + '" data-qid="' + q.id + '">' + val + '</textarea>';
  }

  function renderPhotoUpload(q) {
    var photo = state.photos[q.id];
    var hasFile = !!photo;

    var html = '<div class="pq__upload">';
    if (hasFile) {
      html += '<div class="pq__upload-dropzone pq__upload-dropzone--has-file" data-qid="' + q.id + '">' +
        '<img class="pq__upload-preview" src="' + photo.dataUrl + '" alt="Preview">' +
      '</div>' +
      '<button type="button" class="pq__upload-remove" data-qid="' + q.id + '" aria-label="' + (UI.remove_photo || 'Remove photo') + '">&times;</button>';
    } else {
      html += '<div class="pq__upload-dropzone" data-qid="' + q.id + '">' +
        '<div class="pq__upload-icon">' + ICONS.upload + '</div>' +
        '<div class="pq__upload-text"><strong>' + (UI.click_to_upload || 'Click to upload') + '</strong> ' + (UI.or_drag_drop || 'or drag & drop') + '<br>' + (UI.upload_hint || 'PNG, JPG up to 10MB') + '</div>' +
      '</div>';
    }
    html += '<input type="file" class="pq__upload-input" accept="' + (q.accept || 'image/*') + '" data-qid="' + q.id + '">';
    html += '</div>';
    return html;
  }

  /* ---------- Card Builder ---------- */

  function buildCard(q) {
    var body = '';
    switch (q.type) {
      case 'yes_no':        body = renderYesNo(q); break;
      case 'single_choice': body = renderSingleChoice(q); break;
      case 'picture_choice': body = renderPictureChoice(q); break;
      case 'text':
      case 'email':
      case 'number':        body = renderTextInput(q); break;
      case 'name_email':    body = renderNameEmail(q); break;
      case 'textarea':      body = renderTextarea(q); break;
      case 'photo_upload':  body = renderPhotoUpload(q); break;
    }

    var stepNum = state.history.length + 1;
    var html = '<div class="pq__card pq__card--active" data-qid="' + q.id + '">' +
      '<div class="pq__card-number">' +
        '<svg viewBox="0 0 16 16" fill="currentColor"><path d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z"/><path d="M8 4a.75.75 0 0 1 .75.75V7.25H11a.75.75 0 0 1 0 1.5H8.75v2.5a.75.75 0 0 1-1.5 0v-2.5H5a.75.75 0 0 1 0-1.5h2.25V4.75A.75.75 0 0 1 8 4Z"/></svg>' +
        'Step ' + stepNum +
      '</div>' +
      '<h2 class="pq__card-title">' + q.title + '</h2>' +
      (q.subtitle ? '<p class="pq__card-subtitle">' + q.subtitle + '</p>' : '') +
      (q.helpImage ? '<div class="pq__card-help-img"><img src="' + q.helpImage + '" alt="" fetchpriority="high"></div>' : '') +
      body +
      '<div class="pq__error" id="pqError_' + q.id + '">' +
        ICONS.alert +
        '<span class="pq__error-text"></span>' +
      '</div>' +
      '' +
    '</div>';

    return html;
  }

  function buildEndScreen() {
    return '<div class="pq__card pq__card--active">' +
      '<div class="pq__thankyou">' +
        '<div class="pq__thankyou-icon">' + ICONS.checkCircle + '</div>' +
        '<h2 class="pq__thankyou-title">' + END_SCREEN.title + '</h2>' +
        '<p class="pq__thankyou-subtitle">' + END_SCREEN.subtitle + '</p>' +
      '</div>' +
    '</div>';
  }

  function buildLoadingScreen() {
    return '<div class="pq__card pq__card--active">' +
      '<div class="pq__thankyou">' +
        '<div class="pq__loading-spinner"></div>' +
        '<h2 class="pq__thankyou-title">' + (UI.loading_title || 'We are looking for the best fit for your tap') + '</h2>' +
        '<p class="pq__thankyou-subtitle">' + (UI.loading_subtitle || 'Please wait while we analyze your answers…') + '</p>' +
      '</div>' +
    '</div>';
  }

  /* ---------- Render ---------- */

  function render(direction) {
    var oldCard = qs('.pq__card--active', cardsContainer);

    if (oldCard) {
      var exitClass = direction === 'forward' ? 'pq__card--exit-up' : 'pq__card--exit-down';
      oldCard.classList.remove('pq__card--active');
      oldCard.classList.add(exitClass);
      setTimeout(function () {
        if (oldCard.parentNode) oldCard.parentNode.removeChild(oldCard);
      }, 400);
    }

    var html;
    if (state.finished) {
      html = buildEndScreen();
      nav.style.display = 'none';
    } else {
      var q = QUESTIONS[state.current];
      if (!q) return;
      html = buildCard(q);
    }

    var temp = document.createElement('div');
    temp.innerHTML = html;
    var newCard = temp.firstChild;
    newCard.classList.remove('pq__card--active');
    cardsContainer.appendChild(newCard);

    // Force reflow then animate in
    void newCard.offsetWidth;
    newCard.classList.add('pq__card--active');

    updateNav();
    updateProgress();
    bindCardEvents();

    // Focus first input
    setTimeout(function () {
      var input = qs('.pq__input, .pq__textarea', newCard);
      if (input) input.focus();
    }, 450);
  }

  /* ---------- Navigation State ---------- */

  function updateNav() {
    if (state.finished) return;

    btnBack.disabled = state.history.length === 0;

    var q = QUESTIONS[state.current];
    if (!q) return;

    // For auto-advance types, next button is still shown but might be optional
    var answer = state.answers[q.id];
    var hasAnswer = false;

    switch (q.type) {
      case 'yes_no':
      case 'single_choice':
      case 'picture_choice':
        hasAnswer = !!answer;
        break;
      case 'text':
      case 'email':
      case 'number':
        hasAnswer = !!answer && answer.toString().trim() !== '';
        break;
      case 'name_email':
        hasAnswer = !!state.answers[q.id + '_name'] && state.answers[q.id + '_name'].trim() !== '' &&
                    !!state.answers[q.id + '_email'] && state.answers[q.id + '_email'].trim() !== '';
        break;
      case 'textarea':
        hasAnswer = !q.required || (!!answer && answer.trim() !== '');
        break;
      case 'photo_upload':
        hasAnswer = !!state.photos[q.id];
        break;
    }

    var nextQ = getNextQuestion(q, answer);
    var isLast = nextQ === 'END';

    btnNext.disabled = q.required && !hasAnswer;

    // Update button text
    var span = qs('span', btnNext);
    if (isLast && hasAnswer) {
      span.textContent = UI.submit || 'Submit';
      btnNext.classList.add('pq__btn--submit');
    } else {
      span.textContent = 'Next';
      btnNext.classList.remove('pq__btn--submit');
    }
  }

  /* ---------- Validation ---------- */

  function validate(q) {
    var val = state.answers[q.id];
    var errorEl = document.getElementById('pqError_' + q.id);
    if (!errorEl) return true;
    var textEl = qs('.pq__error-text', errorEl);

    function showError(msg) {
      textEl.textContent = msg;
      errorEl.classList.add('pq__error--visible');
      var input = qs('.pq__input, .pq__textarea', cardsContainer);
      if (input) input.classList.add('pq__input--error');
      return false;
    }

    function clearError() {
      errorEl.classList.remove('pq__error--visible');
      var input = qs('.pq__input, .pq__textarea', cardsContainer);
      if (input) input.classList.remove('pq__input--error');
      return true;
    }

    // Required check
    if (q.required) {
      if (q.type === 'photo_upload') {
        if (!state.photos[q.id]) return showError(UI.error_upload_photo || 'Please upload a photo to continue.');
      } else if (q.type === 'name_email') {
        var nameVal = state.answers[q.id + '_name'];
        var emailVal = state.answers[q.id + '_email'];
        if (!nameVal || nameVal.trim() === '') return showError(UI.error_full_name || 'Please enter your full name.');
        if (!emailVal || emailVal.trim() === '') return showError(UI.error_email_empty || 'Please enter your email address.');
        var emailRe2 = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRe2.test(emailVal)) return showError(UI.error_email_invalid || 'Please enter a valid email address.');
      } else if (!val || val.toString().trim() === '') {
        return showError('This field is required.');
      }
    }

    // Type-specific validation
    if (q.validation === 'email' && val) {
      var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRe.test(val)) return showError(UI.error_email_invalid || 'Please enter a valid email address.');
    }

    if (q.validation === 'diameter' && val) {
      var num = parseFloat(val);
      if (isNaN(num) || num <= 0 || num > 100) return showError(UI.error_diameter || 'Please enter a valid diameter between 0 and 100 mm.');
    }

    if (q.validation === 'order_number' && val) {
      if (val.trim().length < 2) return showError(UI.error_order_number || 'Please enter a valid order number.');
    }

    return clearError();
  }

  /* ---------- Navigation Actions ---------- */

  function goNext() {
    var q = QUESTIONS[state.current];
    if (!q) return;

    // Sync input value
    syncInputValue(q);

    if (!validate(q)) return;

    // Create session after name_email question is validated
    if (q.type === 'name_email' && !state._sessionId) {
      initSession(state.answers[q.id + '_email'], state.answers['Q2'] || null);
    }

    var answer = state.answers[q.id];
    var next = getNextQuestion(q, answer);

    state.history.push(state.current);

    if (next === 'END') {
      state.finished = true;
      onComplete();
      return;
    }

    state.current = next;
    render('forward');
  }

  function goBack() {
    if (state.history.length === 0) return;

    state.finished = false;
    state.current = state.history.pop();
    render('backward');
    nav.style.display = '';
  }

  function syncInputValue(q) {
    if (q.type === 'name_email') {
      var nameInput = qs('.pq__input[data-field="name"][data-qid="' + q.id + '"]', cardsContainer);
      var emailInput = qs('.pq__input[data-field="email"][data-qid="' + q.id + '"]', cardsContainer);
      if (nameInput) state.answers[q.id + '_name'] = nameInput.value;
      if (emailInput) state.answers[q.id + '_email'] = emailInput.value;
      return;
    }
    var input = qs('.pq__input[data-qid="' + q.id + '"]', cardsContainer);
    if (input) {
      state.answers[q.id] = input.value;
      return;
    }
    var textarea = qs('.pq__textarea[data-qid="' + q.id + '"]', cardsContainer);
    if (textarea) {
      state.answers[q.id] = textarea.value;
    }
  }

  /* ---------- Complete ---------- */

  function buildPayload(uploadedImages) {
    var answers = {};
    Object.keys(state.answers).forEach(function (key) {
      answers[key] = state.answers[key];
    });

    var market = CONFIG.market || {};

    return {
      quiz_session: {
        session_id: state._sessionId || null,
        answers: answers,
        images: uploadedImages || [],
        // Storefront locale/country at submission time. n8n forwards `locale`
        // to the AI prompt (target language) and to the result metaobject
        // (`market` field) so the proxy page renders in the right language.
        locale: market.locale || null,
        country: market.country || null
      }
    };
  }

  function sendToWebhook(payload) {
    return fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Webhook responded with ' + res.status);
      return res.json();
    })
    .then(function (data) {
      console.log('[Puure Quiz] Submission sent successfully.', data);
      return data;
    });
  }

  function uploadAllImages() {
    var waitForSession = _sessionInitPromise || Promise.resolve(getSessionId());
    return waitForSession.then(function () {
      var sessionId = getSessionId();
      var photoKeys = Object.keys(state.photos);
      if (photoKeys.length === 0) return [];

      var uploads = photoKeys.map(function (qId) {
        var photo = state.photos[qId];

        // 1. Get signed upload URL from backend
        return fetch(UPLOAD_URL_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            session_id: sessionId,
            filename: photo.name,
            mime_type: photo.type
          })
        })
        .then(function (res) {
          if (!res.ok) throw new Error('Failed to get upload URL (' + res.status + ')');
          return res.json();
        })
        .then(function (data) {
          var storagePath = data.storage_path;
          // 2. Upload file directly to Supabase via signed URL
          return fetch(data.uploadUrl, {
            method: 'PUT',
            headers: { 'Content-Type': photo.type },
            body: photo.file
          }).then(function (uploadRes) {
            if (!uploadRes.ok) throw new Error('Upload failed (' + uploadRes.status + ')');
            console.log('[Puure Quiz] Image uploaded:', storagePath);
            // 3. Get signed download URL (file now exists)
            return fetch(DOWNLOAD_URL_ENDPOINT, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ storage_path: storagePath })
            });
          }).then(function (dlRes) {
            if (!dlRes.ok) throw new Error('Failed to get download URL (' + dlRes.status + ')');
            return dlRes.json();
          }).then(function (dlData) {
            return {
              question_key: qId,
              storage_path: storagePath,
              mime_type: photo.type,
              download_url: dlData.downloadUrl
            };
          });
        });
      });

      return Promise.all(uploads);
    });
  }

  function showLoadingScreen() {
    var oldCard = qs('.pq__card--active', cardsContainer);
    if (oldCard) {
      oldCard.classList.remove('pq__card--active');
      oldCard.classList.add('pq__card--exit-up');
      setTimeout(function () {
        if (oldCard.parentNode) oldCard.parentNode.removeChild(oldCard);
      }, 400);
    }

    var temp = document.createElement('div');
    temp.innerHTML = buildLoadingScreen();
    var newCard = temp.firstChild;
    newCard.classList.remove('pq__card--active');
    cardsContainer.appendChild(newCard);
    void newCard.offsetWidth;
    newCard.classList.add('pq__card--active');

    nav.style.display = 'none';
    updateProgress();
  }

  function onComplete() {
    console.log('[Puure Quiz] Uploading images then submitting…');

    // Show loading screen immediately
    showLoadingScreen();

    uploadAllImages()
      .then(function (uploadedImages) {
        var payload = buildPayload(uploadedImages);

        console.log('[Puure Quiz] Submission payload:', payload);

        // Store in window for debugging / external access
        window.__puureQuestionnaireData = payload;

        // Dispatch custom event
        document.dispatchEvent(new CustomEvent('puure:questionnaire:complete', { detail: payload }));

        // Send to n8n webhook
        return sendToWebhook(payload);
      })
      .then(function (data) {
        // Redirect to the filter selection page with the token from n8n response
        var token = data.token;
        if (token) {
          window.location.href = '/apps/filter-selection?token=' + encodeURIComponent(token);
        } else {
          console.error('[Puure Quiz] No token in n8n response:', data);
          showLoadingError();
        }
      })
      .catch(function (err) {
        console.error('[Puure Quiz] Submission failed:', err);
        showLoadingError();
      });
  }

  function showLoadingError() {
    var titleEl = qs('.pq__thankyou-title', cardsContainer);
    var subtitleEl = qs('.pq__thankyou-subtitle', cardsContainer);
    var spinnerEl = qs('.pq__loading-spinner', cardsContainer);
    if (titleEl) titleEl.textContent = UI.error_title || 'Something went wrong';
    if (subtitleEl) subtitleEl.innerHTML = (UI.error_subtitle || 'Please try again later or contact us at') + ' <a href="mailto:dev@puurefilters.com" style="color:#3B4BDB;text-decoration:underline;">dev@puurefilters.com</a>';
    if (spinnerEl) spinnerEl.style.display = 'none';
  }

  /* ---------- Event Binding ---------- */

  function bindCardEvents() {
    var q = QUESTIONS[state.current];
    if (!q) return;

    // Yes / No
    if (q.type === 'yes_no') {
      qsa('.pq__yesno-btn', cardsContainer).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = this.getAttribute('data-value');
          state.answers[q.id] = val;

          qsa('.pq__yesno-btn', cardsContainer).forEach(function (b) {
            b.classList.remove('pq__yesno-btn--selected');
          });
          this.classList.add('pq__yesno-btn--selected');

          updateNav();
          // Auto-advance after short delay
          setTimeout(goNext, 350);
        });
      });
    }

    // Single choice
    if (q.type === 'single_choice') {
      qsa('.pq__choice-btn', cardsContainer).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = this.getAttribute('data-value');
          state.answers[q.id] = val;

          qsa('.pq__choice-btn', cardsContainer).forEach(function (b) {
            b.classList.remove('pq__choice-btn--selected');
          });
          this.classList.add('pq__choice-btn--selected');

          updateNav();
          setTimeout(goNext, 350);
        });
      });
    }

    // Picture choice
    if (q.type === 'picture_choice') {
      qsa('.pq__picture-btn', cardsContainer).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = this.getAttribute('data-value');
          state.answers[q.id] = val;

          qsa('.pq__picture-btn', cardsContainer).forEach(function (b) {
            b.classList.remove('pq__picture-btn--selected');
          });
          this.classList.add('pq__picture-btn--selected');

          updateNav();
          setTimeout(goNext, 350);
        });
      });
    }

    // Name + Email combo
    if (q.type === 'name_email') {
      var neInputs = qsa('.pq__input[data-qid="' + q.id + '"]', cardsContainer);
      neInputs.forEach(function (inp) {
        inp.addEventListener('input', function () {
          var field = this.getAttribute('data-field');
          state.answers[q.id + '_' + field] = this.value;
          updateNav();
          var errorEl = document.getElementById('pqError_' + q.id);
          if (errorEl) errorEl.classList.remove('pq__error--visible');
          this.classList.remove('pq__input--error');
        });
        inp.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            // If on name field, focus email field
            var field = this.getAttribute('data-field');
            if (field === 'name') {
              var emailField = qs('.pq__input[data-field="email"][data-qid="' + q.id + '"]', cardsContainer);
              if (emailField) emailField.focus();
            }
          }
        });
      });
    }

    // Text / Email / Number
    if (q.type === 'text' || q.type === 'email' || q.type === 'number') {
      var input = qs('.pq__input[data-qid="' + q.id + '"]', cardsContainer);
      if (input) {
        input.addEventListener('input', function () {
          state.answers[q.id] = this.value;
          updateNav();
          // Clear error on type
          var errorEl = document.getElementById('pqError_' + q.id);
          if (errorEl) errorEl.classList.remove('pq__error--visible');
          this.classList.remove('pq__input--error');
          // Order number verification
          if (q.validation === 'order_number') {
            debounceVerifyOrder(this.value);
          }
        });
      }
    }

    // Textarea
    if (q.type === 'textarea') {
      var textarea = qs('.pq__textarea[data-qid="' + q.id + '"]', cardsContainer);
      if (textarea) {
        textarea.addEventListener('input', function () {
          state.answers[q.id] = this.value;
          updateNav();
        });
      }
    }

    // Photo upload
    if (q.type === 'photo_upload') {
      var dropzone = qs('.pq__upload-dropzone[data-qid="' + q.id + '"]', cardsContainer);
      var fileInput = qs('.pq__upload-input[data-qid="' + q.id + '"]', cardsContainer);
      var removeBtn = qs('.pq__upload-remove[data-qid="' + q.id + '"]', cardsContainer);

      if (dropzone && fileInput) {
        // Click to upload
        dropzone.addEventListener('click', function () {
          fileInput.click();
        });

        // Drag events
        dropzone.addEventListener('dragover', function (e) {
          e.preventDefault();
          this.classList.add('pq__upload-dropzone--dragover');
        });
        dropzone.addEventListener('dragleave', function () {
          this.classList.remove('pq__upload-dropzone--dragover');
        });
        dropzone.addEventListener('drop', function (e) {
          e.preventDefault();
          this.classList.remove('pq__upload-dropzone--dragover');
          if (e.dataTransfer.files.length) {
            handleFile(q.id, e.dataTransfer.files[0]);
          }
        });

        // File input change
        fileInput.addEventListener('change', function () {
          if (this.files.length) {
            handleFile(q.id, this.files[0]);
          }
        });
      }

      // Remove button
      if (removeBtn) {
        removeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          delete state.photos[q.id];
          render('forward');
        });
      }
    }
  }

  /* ---------- Endpoints ---------- */
  var UPLOAD_URL_ENDPOINT = '/apps/filter-selection/api/storage/upload-url';
  var DOWNLOAD_URL_ENDPOINT = '/apps/filter-selection/api/storage/download-url';
  var VERIFY_ORDER_ENDPOINT = '/apps/filter-selection/api/verify-order';
  var SESSION_INIT_ENDPOINT = '/apps/filter-selection/api/session/init';

  /* ---------- Order Verification (Q2) ---------- */
  var _verifyTimer = null;
  var _lastVerifiedOrder = '';

  function debounceVerifyOrder(value) {
    if (_verifyTimer) clearTimeout(_verifyTimer);
    var orderNum = (value || '').trim();

    // Update badge to searching state
    var badge = qs('.pq__order-badge', cardsContainer);
    if (!badge) return;

    if (orderNum.length < 2) {
      badge.className = 'pq__order-badge';
      badge.innerHTML = '';
      _lastVerifiedOrder = '';
      return;
    }

    if (orderNum === _lastVerifiedOrder) return;

    badge.className = 'pq__order-badge pq__order-badge--loading';
    badge.innerHTML = '<span class="pq__order-badge-dot"></span> Checking…';

    _verifyTimer = setTimeout(function () {
      verifyOrder(orderNum, badge);
    }, 600);
  }

  function verifyOrder(orderNum, badge) {
    var url = VERIFY_ORDER_ENDPOINT + '?order=' + encodeURIComponent(orderNum);
    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        _lastVerifiedOrder = orderNum;
        if (data.found) {
          badge.className = 'pq__order-badge pq__order-badge--found';
          badge.innerHTML = ICONS.checkCircle + '<span>Order found' + (data.name ? ' (' + data.name + ')' : '') + '</span>';
        } else {
          badge.className = 'pq__order-badge pq__order-badge--not-found';
          badge.innerHTML = ICONS.alert + '<span>Order not found</span>';
        }
      })
      .catch(function () {
        badge.className = 'pq__order-badge';
        badge.innerHTML = '';
      });
  }

  /* ---------- Session Init ---------- */
  var _sessionInitPromise = null;

  function initSession(email, orderNumber) {
    if (_sessionInitPromise) return _sessionInitPromise;
    _sessionInitPromise = fetch(SESSION_INIT_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email || null, order_number: orderNumber || null })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Session init failed (' + res.status + ')');
      return res.json();
    })
    .then(function (data) {
      state._sessionId = data.session_id;
      console.log('[Puure Quiz] Session created:', data.session_id);
      return data.session_id;
    })
    .catch(function (err) {
      console.error('[Puure Quiz] Session init error:', err);
      // Fallback to local UUID so the quiz still works
      state._sessionId = crypto.randomUUID();
      _sessionInitPromise = null;
      return state._sessionId;
    });
    return _sessionInitPromise;
  }

  function getSessionId() {
    if (state._sessionId) return state._sessionId;
    // Fallback — should not happen since initSession is called on first interaction
    state._sessionId = crypto.randomUUID();
    return state._sessionId;
  }

  function isHeicFile(file) {
    if (file.type === 'image/heic' || file.type === 'image/heif') return true;
    var ext = (file.name || '').split('.').pop().toLowerCase();
    return ext === 'heic' || ext === 'heif';
  }

  function showDropzoneConverting(qId) {
    var dropzone = qs('.pq__upload-dropzone[data-qid="' + qId + '"]', cardsContainer);
    if (!dropzone) return;
    dropzone.innerHTML =
      '<div class="pq__upload-converting">' +
        '<div class="pq__loading-spinner" style="width:32px;height:32px;margin:0 auto 12px"></div>' +
        '<div style="font-size:14px;color:#6B7280;">' + (UI.converting_image || 'Converting image…') + '</div>' +
      '</div>';
  }

  function handleFile(qId, file) {
    var ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];
    // Some browsers leave type empty for HEIC — also check extension
    var typeOk = ALLOWED_TYPES.indexOf(file.type) !== -1 || isHeicFile(file);
    if (!typeOk) {
      showInlineError(qId, UI.error_file_type || 'Please upload an image file (JPEG, PNG, WebP, HEIC).');
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      showInlineError(qId, UI.error_file_size || 'File is too large. Maximum 10MB.');
      return;
    }

    // Convert HEIC → JPEG before storing (uses heic-to / libheif 1.21)
    if (isHeicFile(file)) {
      if (typeof HeicTo === 'undefined') {
        showInlineError(qId, UI.error_heic_not_loaded || 'HEIC conversion library not loaded. Please refresh and try again.');
        return;
      }
      showDropzoneConverting(qId);
      HeicTo({ blob: file, type: 'image/jpeg', quality: 0.85 })
        .then(function (convertedBlob) {
          var newName = file.name.replace(/\.heic$/i, '.jpg').replace(/\.heif$/i, '.jpg');
          var convertedFile = new File([convertedBlob], newName, { type: 'image/jpeg' });
          storePhoto(qId, convertedFile);
        })
        .catch(function (err) {
          console.error('[Puure Quiz] HEIC conversion failed:', err);
          showInlineError(qId, UI.error_heic_failed || 'Failed to convert HEIC image. Please try a JPEG or PNG instead.');
        });
      return;
    }

    storePhoto(qId, file);
  }

  function storePhoto(qId, file) {
    var reader = new FileReader();
    reader.onload = function (e) {
      state.photos[qId] = {
        name: file.name,
        size: file.size,
        type: file.type,
        dataUrl: e.target.result,
        file: file
      };
      render('forward');
    };
    reader.readAsDataURL(file);
  }

  function showInlineError(qId, msg) {
    var errorEl = document.getElementById('pqError_' + qId);
    if (!errorEl) return;
    var textEl = qs('.pq__error-text', errorEl);
    textEl.textContent = msg;
    errorEl.classList.add('pq__error--visible');
  }

  /* ---------- Global Events ---------- */

  btnNext.addEventListener('click', goNext);
  btnBack.addEventListener('click', goBack);

  // Keyboard navigation
  document.addEventListener('keydown', function (e) {
    // Don't interfere with typing
    var tag = document.activeElement ? document.activeElement.tagName : '';
    if (tag === 'INPUT' || tag === 'TEXTAREA') return;

    if (e.key === 'Backspace' || (e.key === 'ArrowUp')) {
      e.preventDefault();
      goBack();
    }

    // Number keys for choice selection
    var q = QUESTIONS[state.current];
    if (q && (q.type === 'single_choice' || q.type === 'picture_choice')) {
      var num = parseInt(e.key);
      if (!isNaN(num) && num >= 1) {
        var btns = qsa('.pq__choice-btn, .pq__picture-btn', cardsContainer);
        if (btns[num - 1]) {
          btns[num - 1].click();
        }
      }
      // Letter keys A-Z
      var letter = e.key.toUpperCase();
      if (/^[A-Z]$/.test(letter)) {
        var idx = letter.charCodeAt(0) - 65;
        var choiceBtns = qsa('.pq__choice-btn', cardsContainer);
        if (choiceBtns[idx]) {
          choiceBtns[idx].click();
        }
      }
    }

    // Y/N for yes_no
    if (q && q.type === 'yes_no') {
      if (e.key.toLowerCase() === 'y') {
        var yBtn = qs('.pq__yesno-btn[data-value="yes"]', cardsContainer);
        if (yBtn) yBtn.click();
      }
      if (e.key.toLowerCase() === 'n') {
        var nBtn = qs('.pq__yesno-btn[data-value="no"]', cardsContainer);
        if (nBtn) nBtn.click();
      }
    }
  });

  /* ---------- Preload help images ---------- */
  Object.keys(QUESTIONS).forEach(function (key) {
    var q = QUESTIONS[key];
    if (q.helpImage) { new Image().src = q.helpImage; }
  });

  /* ---------- Init ---------- */
  render('forward');

})();
